export default __webpack_public_path__ + "static/media/about.e2ebed3e.jpg";